import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { useSagOptions } from "./use-sag-options";

const { sagSubscriptionKey } = useSagOptions();

export const sagAuthInterceptor = (config: InternalAxiosRequestConfig) => {
    // https://github.com/axios/axios/issues/5573#issuecomment-1644862647
    config.headers ??= {} as AxiosRequestHeaders;
    config.headers["Ocp-Apim-Subscription-Key"] = sagSubscriptionKey;

    return config;
};

export const addSagAuthInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(sagAuthInterceptor, null, { synchronous: true });
    return httpClient;
};
